import { Stack } from 'libs/ui';
import { styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

export const DelimiterStyled = styled(Stack)(() => ({
  height: 1,
  width: '100%',
  backgroundColor: Colors.gray200,
}));
